import { defineAction } from '~/prix'
import { z } from 'zod'
import trainingPerformedFetchAction from './trainingPerformedFetch.action.json' with { type: 'json' }
import { trainingPerformedObject } from '../trainingPerformedObject'
import trainingObject from '../../training/trainingObject'

const trainingPerformedFetchDefinition = defineAction({
  ...trainingPerformedFetchAction,

  input: z.object({ id: trainingPerformedObject.shape.id, includeDeleted: z.boolean().nullish() }),
  output: trainingPerformedObject.extend({
    training: trainingObject,
  }),
})

export default trainingPerformedFetchDefinition
